import { NotFoundState } from '@roko/ui/components/states/NotFoundState'
import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const NotFoundView = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <NotFoundState
      title={t('notFound.title')}
      description={t('notFound.description')}
      actionLabel={t('notFound.backHome')}
      onAction={() => void navigate({ to: '/' })}
    />
  )
}
